import React from 'react'
import MyTripR from '../Components/MyTripR'
import SidebarLayout from '../Components/sidebar/SidebarLayout'

const MyTrip = () => {
  return (
    <>
      <SidebarLayout>
        <div id="wrapper" className="col-md-12">
          <MyTripR />
        </div>
      </SidebarLayout>
    </>
  )
}

export default MyTrip